import { EntityName } from 'src/types/EntityName';

export const getEntityNameByCount = (
  count: number,
  entityName: EntityName
): string => (count === 1 ? entityName.singular : entityName.plural);
